import $ from "jquery";

handleFormSubmit("#LogInForm");
handleFormSubmit("#RegForm");
handleCreateAccountAnalytics();

function CaptchaAccepted() {
    $('#loginBtn').prop("disabled", false);
}

function handleFormSubmit(formId: string) {
    $(document).on('submit', formId, function (e) {
        const captchaResult = CheckCaptcha();
        if (!captchaResult) {
            $("#dvCapthaError").css('display', 'block');
            e.preventDefault();
        } else {
            $("#dvCapthaError").css('display', 'none');
        }
    });
}

function handleCreateAccountAnalytics() {
    $(document).on('click', '#createAccountBtn', function () {
        const ga = (window as any).ga;
        if (typeof ga === "function") {
            ga('send', 'event', 'Buttons', 'Clicked', 'Create account');
        }
    });
}

function CheckCaptcha() {
    const captcha = $('textarea[name=g-recaptcha-response]').val();
    if (typeof (captcha) === 'undefined' || captcha === null || captcha == "") {
        return false;
    }
    return true;
}
